import {
  GET_LANGUAGES,
} from 'constants/languages';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_LANGUAGES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
